// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CheckRoundSvg from '@rsuite/icon-font/lib/status/CheckRound';
var CheckRound = createSvgIcon({
    as: CheckRoundSvg,
    ariaLabel: 'check round',
    category: 'status',
    displayName: 'CheckRound'
});
export default CheckRound;
